<div
  *ngIf="errorMessages.length > 0"
  class="courseSliderErrorMessagePlaceHolder"
>
  <p-messages severity="error">
    <ng-template pTemplate>
      <div class="p-message-wrapper">
        <div>
          <span class="p-message-icon pi pi-times-circle"></span>
          <span class="p-ml-2">{{ errorMessageHeaderText }}</span>
        </div>
        <div>
          <ul>
            <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
          </ul>
        </div>
      </div>
    </ng-template>
  </p-messages>
</div>
<form [formGroup]="courseForm">
  <div class="general-tab" style="overflow-y: auto;">
    <div class="fields-row">      
      <div class="field field-title field-required">
        <bpt-text-input
          label="Name"
          [ngClass]="{ 'error-highlight': mandatoryFields.name }"
          id="name"
          formControlName="name"
          [maxlength]="256"
          [required]="true"
        ></bpt-text-input>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Status"
          [options]="courseBindData?.statuses ?? []"
          id="status"
          formControlName="status"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.status }"
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
        label="Format"
        [options]="courseBindData?.formats ?? []"
        [editable]="false"
        formControlName="format"
        id="format"
        [showClear]="true"
        [showFilter]="true"
        [valueField]="valueField"
        [labelField]="labelField"
        [ngClass]="{ 'error-highlight': mandatoryFields.format }"
        [required]="true"
        (ngModelChange)="validateFormat()"
        [disabled]="isFormatEnabled"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Type"
          [options]="courseBindData?.types ?? []"
          id="type"
          formControlName="type"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-text-input
          label="Legacy Course #"
          id="legacyCourseNumber"
          formControlName="legacyCourseNumber"
          [maxlength]="255"
        ></bpt-text-input>
      </div>
    </div>
    <div class="fields-row">
      <div class="field">
        <bpt-numeric-input
          label="Validity Period"
          formControlName="validityPeriodRange"
          [showButtons]="true"
          (numericInputKeyUp)="onRecommendedMaxAttendeesAndValidityPeriodChange($event)"
          id="validityPeriodRange"
          [allowKeyboardIncrement]="true"
          (ngModelChange)="validateRadioButtons()"
        >
        </bpt-numeric-input>
      </div>
      <div class="field">
        <div class="grid">
          <div class="col m-0">
            <p-radioButton class="radioButton"
              name="validityPeriodInterval"
              id="validityPeriodIntervalDays"
              value="0"
              label="Day(s)"
              formControlName="validityPeriodInterval"
              [required]="isValidityPeriodRangeEntered"
              [ngClass]="{ 'error-highlight': mandatoryFields.validityPeriodInterval }"
            >
            </p-radioButton>
          </div>
          <div class="col m-0">
            <p-radioButton class="radioButton"
              name="validityPeriodInterval"
              id="validityPeriodIntervalMonths"
              value="1"
              label="Month(s)"
              formControlName="validityPeriodInterval"
              [required]="isValidityPeriodRangeEntered"
              [ngClass]="{ 'error-highlight': mandatoryFields.validityPeriodInterval }"
            >
            </p-radioButton>
          </div>
          <div class="col m-0">
            <p-radioButton class="radioButton"
              name="validityPeriodInterval"
              id="validityPeriodIntervalYears"
              value="2"
              label="Year(s)"
              formControlName="validityPeriodInterval"
              [required]="isValidityPeriodRangeEntered"
              [ngClass]="{ 'error-highlight': mandatoryFields.validityPeriodInterval }"
            >
            </p-radioButton>
          </div>
          <div class="col align-self-center">
            <i class="fa fa-info-circle infoIcon" pTooltip="{{validityPeriodToolTip}}" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div class="field">
          
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="eQMS Scope(s)"
          [options]="eQMSScopesList"
          [editable]="false"
          formControlName="eqmsScopes"
          id="courseScope"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [multiSelect]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.eqmsScopes }"
          [required]="true"
          (ngModelChange)="validateEqmsScopes()"
        >
        </bpt-dropdown>
      </div>
      <div class="field">

      </div>
      <div class="field">

      </div>
    </div>
    <div class="fields-row">
      <div class="field">
        <bpt-text-input
        formControlName="description"
        [highlightAllOnFocus]="true"
        [multiLine]="true"
        id="description"
        label="Description"
        [required]="true"
        [ngClass]="{ 'error-highlight': mandatoryFields.description }"
      ></bpt-text-input>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
        label="Owner(s)"
        [options]="ownersUserList"
        [multiSelect]="true"
        [editable]="false"
        formControlName="owners"
        id="owners"
        [showClear]="true"
        [showFilter]="true"
        [valueField]="valueField"
        [labelField]="labelField"
        [ngClass]="{ 'error-highlight': mandatoryFields.owners }"
        [required]="true"
      >
      </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
        label="Qualified Trainer(s)"
        [options]="qualifiedTrainersUserList"
        [multiSelect]="true"
        [disabled]="true"
        [editable]="false"
        formControlName="qualifiedTrainers"
        id="qualifiedTrainers"
        [showClear]="true"
        [showFilter]="true"
        [valueField]="valueField"
        [labelField]="labelField"
      >
      </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-numeric-input
        label="Recommended Max # of Attendees"
        formControlName="recommendedMaxAttendees"
        [showButtons]="true"
        (numericInputKeyUp)="onRecommendedMaxAttendeesAndValidityPeriodChange($event)"
        id="recommendedMaxAttendees"
        [allowKeyboardIncrement]="true"
        [required]="ifFormatIsInstructorLed"
        [ngClass]="{ 'error-highlight': mandatoryFields.recommendedMaxAttendees }"
      >
      </bpt-numeric-input>
      </div>
    </div>
    <div class="fields-row">
      <div class="field">
        <bpt-text-input
        formControlName="estimatedDuration"
        [highlightAllOnFocus]="true"
        id="estimatedDuration"
        label="Estimated Duration"
      ></bpt-text-input>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
        label="Scoring Option"
        [options]="courseBindData?.scoringOptions ?? []"
        [editable]="false"
        formControlName="scoringOptions"
        id="scoringOptions"
        [showClear]="true"
        [showFilter]="true"
        [valueField]="valueField"
        [labelField]="labelField"
        [ngClass]="{ 'error-highlight': mandatoryFields.scoringOptions }"
        [required]="true"
        (dropdownChange)="validateScoringOption()"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-numeric-input
        label="Minimum Passing Score"
        formControlName="minimumPassingScore"
        [showButtons]="true"
        (numericInputKeyUp)="onMinimumPassingScoreChange($event)"
        id="minimumPassingScore"
        [allowKeyboardIncrement]="true"
        [required]="ifScoringOptionIsMinimumScore"
        [ngClass]="{ 'error-highlight': mandatoryFields.minimumPassingScore }"
        [maxValue]=100
        >
        </bpt-numeric-input>
      </div>
      <div class="field-required">
        <div class="field field-required">
          <bpt-dropdown
          label="Proficiency Quiz"
          [options]="courseBindData?.proficiencyQuizTypes ?? []"
          formControlName="proficiencyQuiz"
          id="proficiencyQuizTypes"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [required]="true"
          [ngClass]="{'error-highlight': mandatoryFields.proficiencyQuiz}"
          >
          </bpt-dropdown>
        </div>
        </div>
    </div>
    <div class="buttons">
      <p-button
      appPreventDoubleClick
      *ngIf="isEditSlider"
      label="Save"
      type="submit"
      id="generalDetailsSaveButton"
      class="align-right"
      styleClass="bpt-button-compact"
      (debounceClick)="saveCourse()"
    >
    </p-button>
      <p-button
      appPreventDoubleClick
        label="Next"
        type="submit"
        id="generalDetailsSaveButton"
        styleClass="bpt-button-compact"
        class="align-right mr-3"
        (debounceClick)="openNextTab()"
      >
      </p-button>
    </div>
  </div>
</form>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]= "InactiveAssignmentGroupField"  (confirmed)="saveDocumentwithInactiveAssignmentGroup(true)" (dialogClosed)="closeConfirmationDailog($event)"></app-confirmation-dialog>
